// Function to check if a cookie exists
function checkCookie(cookieName) {
  let cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName + "=") == 0) {
      return cookie.substring((cookieName + "=").length, cookie.length);
    }
  }
  return null;
}

// Function to observe DOM changes (e.g., consent banner changes)
function trackConsentChange() {
  let consentCookie = checkCookie('cookie_consent');
  console.log("Initial cookie consent:", consentCookie);

  // Use MutationObserver to watch for changes in the DOM (specific to consent banner area)
  const targetNode = document.body; // Assuming body or consent banner container
  const config = { attributes: true, childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    let newConsentStatus = checkCookie('cookie_consent');
    if (newConsentStatus !== consentCookie) {
      if (newConsentStatus) {
        console.log('Cookies are now accepted:', newConsentStatus);
      } else {
        console.log('Cookies are now refused or consent revoked.');
      }
      consentCookie = newConsentStatus; // Update the last known status
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  // You can stop the observer if needed
  // observer.disconnect();
}

// Call the tracking function
trackConsentChange();
